// removed by extract-text-webpack-plugin
module.exports = {"auction-title":"auction-title___3hqOH","calendar":"calendar___3Pjoc","aDropDown":"aDropDown___EAby_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/FindAuctions.scss
// module id = 3YYH
// module chunks = 60